<!--
 * @Description: App.vue
 * @Date: 2022-03-21 12:16:32
 * @LastEditTime: 2022-03-21 12:21:49
-->
<template>
  <!-- keep-alive 缓存首页，返回时触发 activated 刷新数据而不重复叠加 -->
  <keep-alive include="MainHome">
    <router-view />
  </keep-alive>
</template>

<script>
export default {
  name: 'App',
  mounted() {
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}


</style>
